<div style="padding: 24px;">
    <h5 mat-dialog-title class="text-center">Usuarios</h5>
    <div mat-dialog-content>
        <ng-container>
            <!-- start::FILTERS -->
            <div class="form-filtration container">
                <div class="row align-items-center">
                    <div class="col-md-6 kt-margin-bottom-10-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput placeholder="Search user" #searchInput placeholder="Buscar / Search">
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <!-- end::FILTERS -->

            <!-- start: TABLE -->
            <div class="mat-table__wrapper">
                <mat-table class="lmat-elevation-z8"
                    #table
                    [dataSource]="usersList"
                    #sort1="matSort"
                    matSort
                    matSortDirection="asc">

                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Id</mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <span class="ellipsis">{{row.id}}</span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="names">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Nombres / Name</mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <span class="ellipsis">{{row.names}}</span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="lastnames">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Apellidos / Last Name</mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <span class="ellipsis">{{row.lastnames}}</span>
                        </mat-cell>
                    </ng-container>

                  <ng-container matColumnDef="email">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Correo electrónico/ Email</mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <span class="ellipsis">{{row.email}}</span>
                        </mat-cell>
                    </ng-container>

                  <ng-container matColumnDef="phone">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Teléfono / Phone</mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <span class="ellipsis">{{numberToPhone(row.phone)}}</span>
                        </mat-cell>
                    </ng-container>

                  <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef>Acciones / Edit</mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <button mat-icon-button color="primary" matTooltip="Editar usuario / Edit User" (click)="changeView(3, row)">
                                <mat-icon>create</mat-icon>
                            </button>&nbsp;
                            <button mat-icon-button color="warn" matTooltip="Eliminar usuario / Delete User" type="button" (click)="deleteUser(row.id)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>

                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

                  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                </mat-table>
                <div class="mat-table__message" *ngIf="!usersResult[0] && isLoaded">Sin registros / No Records</div>
                <!-- Message for empty data  -->
                <div class="mat-table__message d-flex justify-content-center" *ngIf="!isLoaded" style="height: 4rem;">
                    <span class="spinner spinner-md spinner-primary"></span>
                </div>
            </div>
            <!-- end: TABLE -->

          <!-- start: PAGINATOR -->
            <div class="mat-table__bottom">
                <mat-paginator [pageSize]="usersPageConf.elementsPerPage" [pageSizeOptions]="usersPageConf.pageSize" [length]="usersPageConf.totalItems" [showFirstLastButtons]="true" (page)="updateUsers($event)"></mat-paginator>
            </div>
            <!-- end: PAGINATOR -->
            <br-alert *ngIf="showAlert"></br-alert>
        </ng-container>

        <!--begin::Form-->
        <ng-container *ngIf="viewModal === 2">
            <h5 class="text-center mt-4 mb-0">Añadir usuario / Add User</h5>
            <form class="form" [formGroup]="createUserForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
                <div class="form-group">
                    <mat-form-field class="w-100">
                        <mat-label>Nombres / Name</mat-label>
                        <input matInput type="text"
                          formControlName="name" autocomplete="off" />
                        <mat-error *ngIf="isControlHasError('name', 'required')">
                          <strong>Campo requerido / Required Field</strong>
                        </mat-error>
                      </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Apellidos / Last Name</mat-label>
                        <input matInput type="text"
                          formControlName="lastName" autocomplete="off" />
                        <mat-error *ngIf="isControlHasError('lastName', 'required')">
                          <strong>Campo requerido / Required Field</strong>
                        </mat-error>
                      </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Cedula / ID</mat-label>
                        <input matInput type="number"
                          formControlName="identification" autocomplete="off" />
                        <mat-error *ngIf="isControlHasError('identification', 'required')">
                          <strong>Campo requerido / Required Field</strong>
                        </mat-error>
                      </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Celular / Telefono / Phone / Mobile</mat-label>
                        <input matInput type="text" [textMask]="{mask: mask}"
                          formControlName="phone" autocomplete="off" />
                        <mat-error *ngIf="isControlHasError('phone', 'required')">
                          <strong>Campo requerido</strong>
                        </mat-error>
                      </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Correo electrónico / Email</mat-label>
                      <input matInput type="text" style="text-transform:lowercase"
                             formControlName="email" autocomplete="off"/>
                        <mat-error *ngIf="isControlHasError('email', 'required')">
                          <strong>Campo requerido / Required Field</strong>
                        </mat-error>
                        <mat-error *ngIf="isControlHasError('email', 'email')">
                          <strong>Correo electrónico invalido / Invalid Email</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </form>
        </ng-container>
        <!--end::Form-->

        <!--begin::Form-->
        <ng-container *ngIf="viewModal === 3">
            <h5 class="text-center mt-4 mb-0">Editar usuario / Edit User</h5>
            <form class="form" [formGroup]="editUserForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
                <div class="form-group">
                    <mat-form-field class="w-100">
                        <mat-label>Nombres / Names </mat-label>
                        <input matInput type="text"
                          formControlName="name" autocomplete="off" />
                        <mat-error *ngIf="isControlHasError('name', 'required')">
                          <strong>Campo requerido / Required Field</strong>
                        </mat-error>
                      </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Apellidos / Last Name</mat-label>
                        <input matInput type="text"
                          formControlName="lastName" autocomplete="off" />
                        <mat-error *ngIf="isControlHasError('lastName', 'required')">
                          <strong>Campo requerido / Required Field </strong>
                        </mat-error>
                      </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Cedula / ID</mat-label>
                        <input matInput type="number"
                          formControlName="identification" autocomplete="off" />
                        <mat-error *ngIf="isControlHasError('identification', 'required')">
                          <strong>Campo requerido / Required Field</strong>
                        </mat-error>
                      </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Celular / Telefono / Phone / Mobile</mat-label>
                        <input matInput type="text" [textMask]="{mask: mask}"
                          formControlName="phone" autocomplete="off" />
                        <mat-error *ngIf="isControlHasError('phone', 'required')">
                          <strong>Campo requerido</strong>
                        </mat-error>
                      </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Correo electrónico / Email</mat-label>
                      <input matInput type="text" style="text-transform:lowercase"
                             formControlName="email" autocomplete="off"/>
                        <mat-error *ngIf="isControlHasError('email', 'required')">
                          <strong>Campo requerido / Required Field </strong>
                        </mat-error>
                        <mat-error *ngIf="isControlHasError('email', 'email')">
                          <strong>Correo electrónico invalido / Invalid Email</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </form>
        </ng-container>
        <!--end::Form-->
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">Cerrar</button>
        <button mat-button cdkFocusInitial (click)="changeView(2, null)" *ngIf="viewModal !== 2">Nuevo</button>
        <button mat-button cdkFocusInitial (click)="addUser(createUserForm)" *ngIf="viewModal === 2" [ngClass]="{ 'spinner spinner-right spinner-md spinner-light': loading }">Crear</button>
        <button mat-button cdkFocusInitial (click)="editUser(editUserForm)" *ngIf="viewModal === 3" [ngClass]="{ 'spinner spinner-right spinner-md spinner-light': loading }">Editar</button>
    </div>
</div>
